module.exports = {
    TOKEN_ADDR: "0x066d3c01b0EBe362E171DE3d0AB8D5743C05c1Fc",
    CONTRACT_ADDR: "0x7e8C33281eBC05A48Ff77375355987530c18A736"
}